<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>
    Signature
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-3">
  <app-digital-signature-image *ngIf="meta.signature_url; else showSignaturePad" [meta]="meta"></app-digital-signature-image>

  <ng-template #showSignaturePad>
    <app-digital-signature (meta_output)="onSave($event)" [meta]="meta"></app-digital-signature>
  </ng-template>
</mat-dialog-content>
